import { defineComponent as _defineComponent } from 'vue'
import { useLocalization } from '~/composables/_next/useLocalization';

type SplitPrice = {
  type: keyof NumberFormatPartTypeRegistry;
  value: string | number;
  class: string;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'FormatPrice',
  props: {
  price: {
    type: Number,
    default: 0,
  },
  isDiscount: {
    type: Boolean,
    default: false,
  },
  isOldPrice: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {



const { country, currency } = useLocalization();

/**
 * Converts a two-letter language code to a specific regional language code.
 * If the language code is not recognized, it returns "fr-FR" by default.
 * @param {string} languageCode The two-letter language code (e.g., "fr", "it").
 * @return {string} The specific regional language code (e.g., "fr-FR", "it-IT") or "fr-FR" if the code is not recognized.
 */
function convertToSpecificRegionalCodeOrDefault(languageCode: string): string {
  const mapping = {
    fr: 'fr-FR',
    it: 'it-IT',
    de: 'de-DE',
    en: 'en-GB',
    es: 'es-ES',
  };

  return mapping[languageCode] || 'fr-FR';
}

/**
 * Formats a price value using Intl.NumberFormat and separates the parts for
 * finer control over styling by adding specific CSS classes.
 *
 * @param      {number}        amount                     The amount
 * @param      {string}        locale                     The locale used for
 *                                                        formatting the price.
 * @param      {string}        [money=currency]  The money
 *
 * @return     {SplitPrice[]}  An array containing the formatted parts of the
 *                             price, each with its own class constructed from
 *                             the number part type (e.g. `decimal`, `literal`,
 *                             `fraction`, etc.).
 */
function formatPriceAndSeparateDetails(amount: number): SplitPrice[] {
  const formatter = new Intl.NumberFormat(convertToSpecificRegionalCodeOrDefault(country), {
    style: 'currency',
    currency,
  });

  try {
    const formattedPrice = formatter.formatToParts(amount);

    return formattedPrice.map((part, index) => {
      let className = 'price-display__';

      if (part.type === 'decimal' || part.type === 'literal') {
        className += 'literal';
      } else {
        className += part.type;
      }

      return {
        type: part.type,
        value: part.value,
        class: className,
      };
    });
  } catch (err) {
    console.error(err);
  }
}

/**
 * Formats a price value using Intl.NumberFormat whenever the `formatToParts` is unavailable (Safari < 13).
 * @param {number} amount - The price value to format.
 * @returns {string} The formated price.
 */
function formatPrice(amount: number): string {
  const formatter = new Intl.NumberFormat(convertToSpecificRegionalCodeOrDefault(country), {
    style: 'currency',
    currency,
  });
  return formatter.format(amount);
}

return { __sfc: true,country, currency, convertToSpecificRegionalCodeOrDefault, formatPriceAndSeparateDetails, formatPrice }
}

})